import React from 'react';

const SmallCard = ({ name, product, types, onClick, isSelected }) => {
  return (
    <div
      className={`group relative max-w-sm w-full bg-gray-800 rounded-lg shadow-lg overflow-hidden transition-transform transform hover:scale-105 cursor-pointer ${isSelected ? 'border-4 border-blue-500' : ''
        }`}
      onClick={onClick}
    >
      {/* Encabezado */}
      <div className="bg-purple-600 text-white font-bold text-center p-4 text-lg">
        {name}
      </div>

      {/* Cuerpo */}
      <div className="p-5 bg-[#2C3E50] text-gray-300">
        <p className="text-sm">
          <span className="font-semibold text-gray-400">Product:</span> {product}
        </p>
        <p className="text-sm mt-2">
          <span className="font-semibold text-gray-400">Type:</span>{' '}
          {types.join(', ')}
        </p>
      </div>

      {/* Hover */}
      <div className="absolute inset-0 border-2 border-transparent group-hover:border-purple-500 rounded-lg transition-all duration-300"></div>
    </div>
  );
};

export default SmallCard;



